// extracted by mini-css-extract-plugin
export default {"Rcard":"ReferralCard_Rcard__tfuVJ","ReferralTxt":"ReferralCard_ReferralTxt__nc8Fo"};